/**
 * Copyright © 2026 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React, { useEffect, useState  } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function ErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const message = query.get('message');

  const [storedMessage, setStoredMessage] = useState('');

  useEffect(() => {
    const messageParam = query.get('message');
    if (messageParam) {
      setStoredMessage(messageParam); // Store in state first
      query.delete('message');
      const newQueryString = query.toString();
      navigate(`${location.pathname}${newQueryString ? '?' + newQueryString : ''}`, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  const isAccessDenied = storedMessage === 'access_denied';
  const secondLine = isAccessDenied
    ? 'Failed to provision account. Insufficient privileges. Access Denied.'
    : 'An unknown error occurred during QBO connection.';

  const thirdLine = 'Please try again later or contact customer support.';
  return (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '70vh',
        padding: '2rem',
        fontFamily: 'var(--zamp-font-body)',
        textAlign: 'center',
        color: '#333'
    }}>
      <div style={{ fontSize: '3rem' }}>
        ⚠️
      </div>
      <h1 style={{ fontFamily: 'var(--zamp-font-headline)', fontWeight: 'normal', marginTop: '1rem', letterSpacing: 'var(--zamp-tracking-headline)' }}>
        Something went wrong
      </h1>

      <p style={{ fontSize: '1.25rem', fontWeight: 'normal', margin: '0.75rem 0' }}>
        {secondLine}
      </p>

      <p style={{ fontSize: '0.85rem', fontWeight: 'normal', color: '#777' }}>
        {thirdLine}
      </p>
      </div>
  );
}

export default ErrorPage;
